import PropTypes from "prop-types";
import React from "react";
import { FunctionField } from "react-admin";
import { formatDate } from "../../Helper/MomentHelper";
/**
 * @example
 * */

export const CustomDateField = props => {
  const { showTime, ...rest } = props;

  return (
    <FunctionField
      {...rest}
      render={record => {
        let source = "";
        if (props?.source?.includes?.(".")) {
          const sourceList = props?.source?.split(".");
          let dataRecord = record as any;
          sourceList.forEach(element => {
            if (dataRecord != null) {
              dataRecord = dataRecord[element];
            }
          });
          source = dataRecord;
        } else {
          source = record?.[props.source];
        }

        return source
          ? formatDate(source, showTime)
          : // moment(source).format(
            //     format || (showTime ? 'DD/MMM/yyyy HH:mm' : 'DD/MMM/yyyy')
            //   )
            "";
      }}
    />
  );
};

CustomDateField.propTypes = {
  source: PropTypes.string.isRequired,
  showTime: PropTypes.bool,
  ...FunctionField.prototype,
};

CustomDateField.defaultProps = {
  showTime: false,
};

export default CustomDateField;
